import Axios from "axios";
import { ProductSheet } from '../types/product-sheet.types';

// Create a public axios instance without authentication
const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || "/api";
const publicAxios = Axios.create({ baseURL: BASE_API_URL });

export interface ApiResponse<T> {
  code: number;
  message: string;
  data: T;
}

export const productSheetApi = {
  getAllProductSheets: async (): Promise<ApiResponse<ProductSheet[]>> => {
    const response = await publicAxios.get('/product-sheets');
    return response.data;
  },

  downloadProductSheet: async (id: string): Promise<ApiResponse<{ downloadUrl: string; filename: string; version: string }>> => {
    const response = await publicAxios.get(`/product-sheets/${id}/download`);
    return response.data;
  }
};
